// Constants
import { ACTIVE_AUTH_STORAGE_KEY } from "Constants/AuthConstants";

export const getActiveAuthDomain = () =>
  sessionStorage.getItem(ACTIVE_AUTH_STORAGE_KEY);

export const setActiveAuthDomain = (domain) => {
  sessionStorage.setItem(ACTIVE_AUTH_STORAGE_KEY, domain);
};

export const clearActiveAuthDomain = () => {
  sessionStorage.removeItem(ACTIVE_AUTH_STORAGE_KEY);
};
